









import { Component, Vue } from 'vue-property-decorator'
import { TrackSelectWizardTargets } from '@/store/modules/trackselectwizard'

@Component({
  components: {
    TrackSelectWizard: require('@/components/TrackSelectWizard').default
  }
})
export default class Select extends Vue {
  target: any = TrackSelectWizardTargets.ExportToFile
}
